/**
 * @since 0.1.0
 */
import * as F from "effect/Function";
import * as E from "effect/Either";
import * as Schema from "effect/Schema";
import * as ParseResult from "effect/ParseResult";
import { ArrayFormatter } from "effect/ParseResult";
import * as Bounded_ from "@effect/typeclass/Bounded";
import * as AST from "effect/SchemaAST";
import * as Arbitrary from "effect/Arbitrary";
import * as t from "io-ts";
// NOTE: this export is needed when using Schema.Class to avoid error: `The inferred type of <name> references an inaccessible unique symbol type. A type annotation is necessary.`
export const DateTimeBrand = /*#__PURE__*/Symbol.for("DateTime");
const _Arbitrary = fc => fc.date({
  min: minBound,
  max: maxBound
}).map(x => x);
export const DateTime = /*#__PURE__*/F.pipe(Schema.String, /*#__PURE__*/Schema.transformOrFail(Schema.DateFromSelf, {
  decode: s => {
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse
    const result = Date.parse(s);
    return Number.isNaN(result) ? ParseResult.fail(new ParseResult.Type(new AST.Literal(s), null, `Unexpected "${s}", expected DateTime`)) : ParseResult.succeed(clamp(new Date(s)));
  },
  encode: a => ParseResult.succeed(a.toISOString())
}), /*#__PURE__*/Schema.brand(DateTimeBrand, {
  arbitrary: () => _Arbitrary
}));
export const decode = /*#__PURE__*/Schema.decodeUnknownEither(DateTime);
export const encode = /*#__PURE__*/Schema.encodeSync(DateTime);
export const decodeUnsafe = /*#__PURE__*/F.flow(decode, /*#__PURE__*/E.getOrThrowWith(e => new Error(`Invalid DateTime: ${formatParseError(e)}`)));
export const buildUnsafe = decodeUnsafe; //< for backward compatibility
export const isDateTime = /*#__PURE__*/Schema.is(DateTime);
const formatParseError = e => ArrayFormatter.formatErrorSync(e).map(x => x.message).join("\n");
export const DateTimeCodec = /* @__PURE__ */new t.Type("DateTime", isDateTime, (input, ctx) => F.pipe(decode(input), E.match({
  onLeft: e => t.failure(input, ctx, formatParseError(e)),
  onRight: t.success
})), a => a.toISOString());
export const Equivalence = (self, that) => self.getTime() === that.getTime();
export const Order = (self, that) => Math.sign(self.getTime() - that.getTime());
export const maxBound = /*#__PURE__*/new Date( /*#__PURE__*/Date.UTC(9999, 11, 31, 23, 59, 59));
export const minBound = /*#__PURE__*/new Date( /*#__PURE__*/Date.UTC(1900, 0, 1));
export const Bounded = {
  maxBound,
  minBound,
  compare: Order
};
export const any = /*#__PURE__*/Arbitrary.make(DateTime);
export const now = () => clamp(new Date());
export const addDays = (date, days) => clamp(new Date(date.getTime() + days * ONE_DAY_IN_MILLIS));
export const addHours = (date, hours) => clamp(new Date(date.getTime() + hours * ONE_HOUR_IN_MILLIS));
const ONE_DAY_IN_MILLIS = 24 * 60 * 60 * 1000;
const ONE_HOUR_IN_MILLIS = 60 * 60 * 1000;
const clamp = /*#__PURE__*/Bounded_.clamp(Bounded);
//# sourceMappingURL=DateTime.js.map